import { render, staticRenderFns } from "./StoriesCarousel.vue?vue&type=template&id=3f3fb52f"
import script from "./StoriesCarousel.vue?vue&type=script&lang=js"
export * from "./StoriesCarousel.vue?vue&type=script&lang=js"
import style0 from "./StoriesCarousel.vue?vue&type=style&index=0&id=3f3fb52f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports